import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import projectStyle from "../projectStyle";
import ProjectCard from "./ProjectCard";

//Project responsive style and format for mobile view
const ProjectCarousel = ({ projects, toggleSection }) => {
  const classes = projectStyle();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < projects.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <Box className={classes.mobileCarouselContainer}>
      {/* Left Navigation Button */}
      <Box className={classes.navWrapper}>
        {currentIndex > 0 ? (
          <IconButton className={`${classes.navButton} ${classes.leftNav}`} onClick={handlePrev}>
            <ArrowBackIos />
          </IconButton>
        ): (
          // Invisible placeholder
          <div className={classes.navPlaceholder} />
        )}
      </Box>

      {/* Display the Current Project Card */}
      <Box className={classes.cardWrapper} onClick={() => toggleSection(
        currentIndex === 0 ? "history"
        : currentIndex === 1 ? "vision"
        : currentIndex === 2 ? "ourVision"
        : null)}>
        <ProjectCard
          project={projects[currentIndex]}
        />
      </Box>

      {/* Right Navigation Button */}
      <Box className={classes.navWrapper}>
        {currentIndex < projects.length - 1 ? (
          <IconButton className={`${classes.navButton} ${classes.rightNav}`} onClick={handleNext}>
            <ArrowForwardIos />
          </IconButton>
        ): (
          <div className={classes.navPlaceholder} />
        )}
      </Box>
    </Box>
  );
};

export default ProjectCarousel;
